module.exports = __webpack_public_path__ + "img/image_word.936c95fa.png";